import React from 'react';
import { HeadingLayout, HeadingOne, HeadingTwo, Modal } from 'src/features/common';
import { BCASubmitStatus } from '../business-cash-advance-calculation';
import { LoaderAnimation } from 'src/components';

type SubmitModalProps = {
  show: boolean;
  status: BCASubmitStatus;
};

type StatusHeadings = {
  main: string;
  sub: string;
};

export function SubmitModal({ show, status }: SubmitModalProps) {
  const getStatus = (status?: string): StatusHeadings => {
    switch (status) {
      case BCASubmitStatus.COLLECTING_INFO:
        return {
          main: 'We are collecting your information',
          sub: 'This should only take a moment',
        };

      case BCASubmitStatus.PREPARING_APPLICATION:
        return {
          main: 'Your application is being prepared',
          sub: 'This should only take a moment',
        };

      case BCASubmitStatus.SUBMITTING_APPLICATION:
        return { main: 'Submitting your application', sub: 'This should only take a moment' };

      default:
        return { main: 'Things are taking longer than usual', sub: 'Please be patient' };
    }
  };

  return (
    <Modal size="small" visible={show}>
      <div className="paymentModal">
        <LoaderAnimation height={'6rem'} width={'7rem'} />
        <HeadingLayout
          renderMainHeading={() => <HeadingOne>{getStatus(status).main}</HeadingOne>}
          renderSubHeading={() => <HeadingTwo>{getStatus(status).sub}</HeadingTwo>}
        />
      </div>
    </Modal>
  );
}
